import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';

import {LanguageDropdownModule} from 'shared/language-dropdown/language-dropdown.module';
import {ContentsDetailsRoutingModule} from './contents-details-routing.module';
import {ContentsDetailsComponent} from './contents-details.component';
import {ContentsDetailsHttpRepository} from './repositories/contents-details.repository.http';
import {ContentsDetailsService} from './services/contents-details.service';
import { ContentDatepickerModule } from './content-datepicker/content-datepicker.module';

import {DragulaModule} from 'ng2-dragula';
import {TooltipModule} from 'ng2-bootstrap/tooltip';
import { TabsModule, TabsetConfig } from 'ng2-bootstrap/tabs';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ContentsDetailsRoutingModule,
    LanguageDropdownModule,
    DragulaModule,
    ContentDatepickerModule,
    TooltipModule.forRoot(),
    TabsModule
  ],
  declarations: [
    ContentsDetailsComponent,
  ],
  providers: [
    ContentsDetailsService,
    {
      provide: 'IContentsDetailsRepository',
      useClass: ContentsDetailsHttpRepository,
    },
    TabsetConfig
  ],
})
export class ContentsDetailsModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/contents/contents-details/contents-details.module.ts